import React, { useState } from "react";
import "./table.css";
import DataTable from 'react-data-table-component';
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { DataAPi } from "../variable/dataVariable";

function TableRekap({dataSet}) {
    const columns = [
        {
            name: 'Nomor',
            selector: row => row.id,
            sortable: true,
        },
        {
            name: 'Nama Barang',
            selector: row => row.namaBarang,
            sortable: true,
        },
        {
            name: 'Kategori',
            selector: row => row.kategori,
            sortable: true,
        },
        {
            name: 'Kondisi',
            selector: row => row.kondisi,
            sortable: true,
        },
        {
            name: 'Tanggal Pembelian',
            selector: row => row.tanggalBeli,
            sortable: true,
        },
        {
            name: 'Jenis Aset',
            selector: row => row.jenisAset,
            sortable: true,
        },
        {
            name: 'Tahun Anggaran',
            selector: row => row.tahunAnggaran,
            sortable: true,
        },
        {
            name: 'Menu',
            selector: row => row.menu,
            width: "190px",
        },
        
    ];

    
    const person = [];
    let kon = "name"

    const setData = (id, name) => {
        person["id"] = id;
        person["name"] = name;
        console.log(person);
        
    }

        
    const deleteAset = (id) =>{
        axios.delete(DataAPi.urlDelete + id)
        .then((res) => {
            window.location.reload()
        })
        .catch((error) =>{console.log(error)})
    }

    const data = dataSet.map((aset, index) => {

        
        return(
            {
                id: aset.id,
                namaBarang: aset.namaBarang,
                kategori: aset.kategori,
                kondisi: aset.kondisi,
                tanggalBeli: aset.tanggalBeli,
                jenisAset: aset.jenisAset,
                tahunAnggaran: aset.tahunAnggaran,
                menu: <div>
                    <Link className="btn btn-primary m-1" to={`/rincian/aset/${aset.id}`}>
                        <i class="bi bi-file-post text-white"></i>
                    </Link>
                    <Link c className="btn btn-success m-1" to={`/edit/aset/${aset.id}`}>
                        <i class="bi bi-pencil-square text-white"></i>
                    </Link>
                    <button type="button" class="btn btn-danger" onClick={() => {setData(aset.id, aset.namaBarang)}} data-bs-toggle="modal" data-bs-target="#exampleModal">
                        <i class="bi bi-trash text-white"></i>
                    </button>

                    <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div class="modal-dialog">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h1 class="modal-title fs-5" id="exampleModalLabel">Peringatan</h1>
                                </div>
                                <div class="modal-body">
                                    Penghapusan dilakukan apabila aset tersebut sudah rusak parah
                                    <br></br>
                                    (tidak dapat dipergunakan lagi), habis masa pakai aset, atau hilang
                                    <p></p>
                                    Klik "Iya" jika anda ingin menghapus aset
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-danger" data-bs-dismiss="modal" onClick={() => {deleteAset(person["id"])}}>iya</button>
                                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>,
            }
        )
    })

    const [records, setRecords] = useState(data);
    function handlerFilter(event) {
        const newData = data.filter(row => {
            return row.namaBarang.toLowerCase().includes(event.target.value.toLowerCase())
        })
        setRecords(newData)
    }
    return(
        <div className="container table-responsive-sm bg-light m-auto border radius mb-3">
            <div className="text-end p-4">
                <input type="text" placeholder="Pencarian" onChange={handlerFilter}/>
            </div>
            <DataTable
                columns={columns}
                data={records}
                fixedHeader
                pagination
            />
        </div>
    )
}

export default TableRekap;